import { createAsyncThunk } from '@reduxjs/toolkit';
import contactApi from '~/apis/contact';
import {
  CONVERT_TO_CUSTOMER,
  CREATE_CONTACT,
  DELETE_CONTACT,
  GET_CONTACT_LIST,
  GET_DETAIL_CONTACT,
  SEND_EMAIL,
  UPDATE_CONTACT,
} from '~/utils/constants/actionType';
import {
  IBodySendMail,
  IBodyUpdateContact,
  IContactForm,
  IQueryDeleteContact,
  IQueryParamContact,
} from '~/utils/interface/contact';

export const createContact = createAsyncThunk(
  CREATE_CONTACT,
  async (payload: IContactForm, { rejectWithValue }) => {
    try {
      const res = await contactApi.createContact(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getContactList = createAsyncThunk(
  GET_CONTACT_LIST,
  async (params: IQueryParamContact, { rejectWithValue }) => {
    try {
      const resp = await contactApi.getContactList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getContactDetail = createAsyncThunk(
  GET_DETAIL_CONTACT,
  async (id: string, { rejectWithValue }) => {
    try {
      const resp = await contactApi.getContactDetail(id);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateContact = createAsyncThunk(
  UPDATE_CONTACT,
  async (params: IBodyUpdateContact, { rejectWithValue }) => {
    try {
      const resp = await contactApi.updateContact(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendEmail = createAsyncThunk(SEND_EMAIL, async (params: IBodySendMail, { rejectWithValue }) => {
  try {
    const resp = await contactApi.sendEmail(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const convertToCustomer = createAsyncThunk(
  CONVERT_TO_CUSTOMER,
  async (id: string, { rejectWithValue }) => {
    try {
      const resp = await contactApi.convertToCustomer(id);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteContact = createAsyncThunk(
  DELETE_CONTACT,
  async (params: IQueryDeleteContact, { rejectWithValue }) => {
    try {
      const resp = await contactApi.deleteContact(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
